import { Card, CardHeader, makeStyles, mergeClasses, Text, Title2 } from "@fluentui/react-components";
import { mergeStyles } from "@fluentui/merge-styles";
import { Link } from "react-router-dom";
import ICaseStudyPreview from "../../../models/caseStudy/ICaseStudyPreview";
import { MotionLazyScroll } from "../../../components/motion/MotionLazyScroll";

const useStyles = makeStyles({
    root: {
        display: "flex",
        alignSelf: "stretch",
        width: "100%",
        maxWidth: "350px",
    },
    link: {
        textDecoration: "none",
        display: "flex",
        alignSelf: "stretch",
        width: "100%",
    },
    card: {
        width: "100%",
        paddingTop: "3rem",
        paddingBottom: "3rem",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        transition: "transform 0.2s",

        "&:hover": {
            transform: "translateY(-4px)",

            "& div.overlay": {
                backgroundColor: "rgba(0, 0, 0, 0.6)"
            },
        },

        "@media (max-width: 768px)": {
            maxWidth: "100%",
        }
    },
    overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        zIndex: 1,
        transition: "background-color 0.2s"
    },
    title: {
        color: "white",
        zIndex: 2,
        borderBottom: "1px solid white",
        paddingBottom: ".5rem",
        marginTop: "auto",

        "& h2": {
            margin: 0,
            fontSize: "1.5rem"
        }
    },
    description: {
        color: "white",
        zIndex: 2,
        marginTop: 0,
        marginBottom: 0,
        fontSize: "1rem"
    }
});

export default function CaseStudyTile(props: { caseStudy: ICaseStudyPreview }) {
    const caseStudy = props.caseStudy;
    const styles = useStyles();

    const imgClass = mergeStyles({
        backgroundImage: `url(${caseStudy.thumbnail.url})`,
    });

    const cardClass = mergeClasses(styles.card, imgClass);

    const title = <Title2 as="h2">{caseStudy.title}</Title2>;

    return (
        <MotionLazyScroll className={styles.root}>
            <Link to={`/casestudy/${caseStudy.slug}`} className={styles.link}>
                <Card className={cardClass}>
                    <div className={`${styles.overlay} overlay`} />
                    <CardHeader header={title} className={styles.title} />
                    <Text block as="p" className={styles.description}>
                        <strong>{caseStudy.client.name}</strong>
                        <br />
                        {caseStudy.client.industry}
                    </Text>
                </Card>
            </Link>
        </MotionLazyScroll>
    );
}